import { observable } from 'tiny-observable';

// Set from `auth.js` (auth SPA folder)
window.observer = observable();
export const o = window.observer;
